<template>
  <svg
    :width="`${config.size}px`"
    :height="`${config.size}px`"
    viewBox="0 0 512 512"
    :style="`transform: rotate(${config.rotate}deg);`"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    :titile="config.text"
  >
    <g stroke="none" stroke-width="1" :fill="config.color" fill-rule="evenodd">
      <path
        d="M467.718,346C432.69,428.3,351.086,486,256,486S79.31,428.3,44.282,346H0V336H512v10H467.718ZM69.942,346a206.715,206.715,0,0,0,372.117,0H69.942ZM0,166H44.282C79.31,83.7,160.914,26,256,26S432.69,83.7,467.718,166H512v10H0V166Zm442.058,0a206.715,206.715,0,0,0-372.116,0H442.058ZM159.234,116.743l11.735,10.448,13.174-7.606-5.83,14.2,11.8,10.466-15.99-1.717-6.465,14.682-3.206-15.43-15.213-2.051,13.131-7.582Zm88.391-9.686,8.465-25.311,8.381,25.311h25.814l-20.617,15.924,8.465,25.4L256.09,132.284l-21.959,16.092,8.381-25.4L221.9,107.057h25.73Zm80.607,12.528,13.174,7.606,11.735-10.448L350,132.154l13.131,7.582-15.213,2.051-3.206,15.43-6.465-14.682-15.99,1.717,11.8-10.466Z"
      />
      <path
        d="M416.522,165.99A183.909,183.909,0,0,0,256.043,72.02H256A183.909,183.909,0,0,0,95.518,165.99H83.571A193.1,193.1,0,0,1,255,61.87h1.744A193.1,193.1,0,0,1,428.169,165.99H416.522ZM62,263.49c-0.077-2.24-.13-4.487-0.13-6.746V255c0-2.259.053-4.506,0.13-6.746V263.49Zm33.483,82.5A183.91,183.91,0,0,0,256,440.023h0.046A183.91,183.91,0,0,0,416.557,345.99h11.486a193.1,193.1,0,0,1-171.3,103.882H255A193.1,193.1,0,0,1,83.7,345.99H95.483Z"
      />
      <path
        d="M157.118,404.918a11.833,11.833,0,0,0,5.347,4.423,21.393,21.393,0,0,0,8.452,1.47,16.987,16.987,0,0,0,7.159-1.458,11.178,11.178,0,0,0,4.879-4.08,10.1,10.1,0,0,0,1.7-5.588,9.236,9.236,0,0,0-1.546-5.284,11.266,11.266,0,0,0-4.79-3.789,49.139,49.139,0,0,0-8.224-2.369q-5.992-1.356-7.412-2.648a4.226,4.226,0,0,1-1.445-3.3,4.9,4.9,0,0,1,2.04-3.941q2.04-1.635,6.5-1.634,4.283,0,6.475,1.8a7.607,7.607,0,0,1,2.572,5.322l4.714-.355a11.25,11.25,0,0,0-1.825-5.854,10.513,10.513,0,0,0-4.853-3.916,18.625,18.625,0,0,0-7.286-1.33,17.682,17.682,0,0,0-6.817,1.267,9.885,9.885,0,0,0-4.663,3.713,9.436,9.436,0,0,0-1.6,5.258,8.475,8.475,0,0,0,1.3,4.625,10.047,10.047,0,0,0,3.966,3.46,33.864,33.864,0,0,0,7.172,2.319,65.179,65.179,0,0,1,6.615,1.812,7.509,7.509,0,0,1,3.345,2.192,4.834,4.834,0,0,1,1.014,3.054,5.318,5.318,0,0,1-1.052,3.18,6.89,6.89,0,0,1-3.206,2.294,13.675,13.675,0,0,1-4.967.836,14.169,14.169,0,0,1-5.7-1.1,8.36,8.36,0,0,1-3.738-2.89,10.223,10.223,0,0,1-1.533-4.574l-4.638.406A12.527,12.527,0,0,0,157.118,404.918Zm56.882-.7a10.573,10.573,0,0,1-7,2.383,12.042,12.042,0,0,1-6.31-1.749,10.291,10.291,0,0,1-4.3-5.284,22.666,22.666,0,0,1-1.381-8.274,22.167,22.167,0,0,1,1.166-7.134,10.831,10.831,0,0,1,4.042-5.512,12.006,12.006,0,0,1,7.159-2.053,10,10,0,0,1,6.184,1.85,11.49,11.49,0,0,1,3.751,5.905l4.84-1.141a14.743,14.743,0,0,0-5.3-7.983,15.231,15.231,0,0,0-9.376-2.838,18.443,18.443,0,0,0-9.01,2.243,15.191,15.191,0,0,0-6.31,6.564,21.88,21.88,0,0,0-2.218,10.124,25.282,25.282,0,0,0,1.964,9.96,15.271,15.271,0,0,0,5.728,7.083,17.642,17.642,0,0,0,9.77,2.446,15.325,15.325,0,0,0,9.82-3.181,16.555,16.555,0,0,0,5.563-9.237l-4.917-1.242A12.186,12.186,0,0,1,214,404.221Zm26.356,5.956,7.882-28.308q0.505-1.8,1.089-4.359,0.177,0.812,1.166,4.359l7.831,28.308h4.739l10.188-37.152h-4.942L262.48,396.9q-1.14,4.563-1.85,8.085a99.518,99.518,0,0,0-2.889-13.153l-5.322-18.8h-5.93l-7.071,25.089q-0.254.912-1.672,6.868-0.66-3.776-1.571-7.6l-5.652-24.354H225.48l9.858,37.152h5.018Zm69.236,0v-8.9h5.018V397.1h-5.018V373.025h-3.725L288.913,397.1v4.182h16.118v8.9h4.561ZM293.4,397.1l11.633-16.751V397.1H293.4Zm33.63,13.077v-5.195h-5.195v5.195h5.195Zm10.34-3.219a10.192,10.192,0,0,0,8.439,3.853,10.3,10.3,0,0,0,6.754-2.193,13.2,13.2,0,0,0,4.017-6.209,34.1,34.1,0,0,0,1.343-10.555,36.735,36.735,0,0,0-.836-8.781,18.637,18.637,0,0,0-2.307-5.525,10.03,10.03,0,0,0-3.725-3.472,10.986,10.986,0,0,0-5.246-1.2,10.3,10.3,0,0,0-6.728,2.18,13.193,13.193,0,0,0-4.03,6.2,34,34,0,0,0-1.356,10.606q0,10.467,3.675,15.1h0Zm3.371-27.648a5.844,5.844,0,0,1,5.017-2.661,6.357,6.357,0,0,1,5.335,3.015q2.142,3.017,2.142,12.19,0,9.123-2.142,12.165a6.117,6.117,0,0,1-10.568.012q-2.142-3.027-2.141-12.177t2.357-12.544h0Z"
      />
      <template v-if="config.sideText">
        <text
          x="260"
          :y="textOffsetY - 33"
          :font-size="70"
          text-anchor="middle"
          dominant-baseline="middle"
        >
          <tspan id="text">{{ config.text }}</tspan>
        </text>
        <text
          x="260"
          :y="textOffsetY + 33"
          :font-size="70"
          text-anchor="middle"
          dominant-baseline="middle"
        >
          <tspan id="text">{{ config.sideText }}</tspan>
        </text>
      </template>
      <template v-else>
        <text
          x="260"
          :y="textOffsetY"
          :font-size="fontSize"
          text-anchor="middle"
          dominant-baseline="middle"
        >
          <tspan id="text">{{ config.text }}</tspan>
        </text>
      </template>
    </g>
  </svg>
</template>

<script>
export default {
  name: "ProcessBadge",
  props: {
    // 预设样式
    type: {},

    // 自定义文本
    text: {
      type: String,
      default: "Process",
    },

    sideText: {
      type: String,
      default: "",
    },

    // 自定义尺寸
    size: {
      type: Number,
      default: 70,
    },

    // 文本字号
    textSize: {
      type: Number,
      default: 100,
    },

    // 自定义颜色
    color: {
      type: String,
      default: "#000000",
    },

    // 自定义倾斜角度，负数时未逆时针旋转
    rotate: {
      type: Number,
      default: 0,
    },

    baseFontSize: Number,
  },
  computed: {
    // 根据传入配置生成徽标样式
    config() {
      let { type, text, sideText, size, textSize, color, rotate } = this;

      return {
        type,
        text,
        sideText,
        size,
        textSize,
        color,
        rotate,
      };
    },

    // 字号，字号根据字数自动计算
    fontSize() {
      try {
        if (this.baseFontSize) {
          return this.baseFontSize;
        }
        const { text } = this.$props;
        const length = text.length;
        return 140 - length * 8.5;
      } catch (error) {
        return 0;
      }
    },

    // 文本偏移
    textOffsetY() {
      try {
        const _platform = window.navigator.platform;
        return _platform.toLowerCase() === "win32" ? 260 : 260;
      } catch (error) {
        return 260;
      }
    },
  },
};
</script>

<style lang="less" scoped></style>
